import React from 'react';
import SkeletonComponent from '../../../skeleton_loaders/common/SkeletonComponent';

const LexicalSkeleton = ({className}) => {
  return <div className={className || ''}>
    <label><SkeletonComponent /></label>
    <div className='editor-container-richTextLexical'>
      <div className='editor-inner'>
        <SkeletonComponent className='editor-input' style={{borderStyle: 'none'}} />
      </div>
    </div>
  </div>
}

export default LexicalSkeleton;
